import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IClientProps } from 'utils/types/pacakageTypes';
import useStoreDropQuery from 'hooks/queries/common/useStoreDropQuery';
import useClientStatusQuery from 'hooks/queries/common/useClientStatusQuery';
import {
  useClientDelete,
  useClientRegister,
  useClientUpdate,
} from 'hooks/queries/package/clientQuery';
import DefaultModal from 'components/modal/DefaultModal';
import TwoRowTable from 'components/table/TwoRowTable';
import DefaultButton from 'components/button/DefaultButton';
import DefaultSelect from 'components/select/DefaultSelect';
import DefaultInput from 'components/input/DefaultInput';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import { useTranslation } from 'react-i18next';
/**
 * * 앱 > 클라이언트 > 상세 정보 모달
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  inputMode?: boolean;
  selectData?: IClientProps;
}
const ClientDetailModal = ({ visible, setVisible, selectData }: IProps) => {
  const { t } = useTranslation();
  const [inputMode, setInputMode] = useState(false); // 모달 내에서 인풋모드 활성화
  const [inputData, setInputData] = useState<IClientProps>({
    package_id: '',
    os_type: '',
    app_store: '',
    client_version: '',
    client_status: 'test',
    custom_url: '',
    memo: '',
  });
  const { data: storeDropList } = useStoreDropQuery(
    selectData?.os_type ? selectData.os_type : 'android',
  );
  const { data: statusDropList } = useClientStatusQuery();
  const { mutate: clientRegister } = useClientRegister(setVisible);
  const { mutate: clientUpdate } = useClientUpdate(setInputMode, setVisible);
  const { mutate: clientDelete } = useClientDelete(setVisible);

  const handleSelectChange = (val, option) => {
    setInputData({ ...inputData!, [option.name]: val });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData!, [name]: value });
  };

  const handleUpdateClick = () => {
    setInputMode(true);
  };

  const handleModalClose = (e) => {
    const { name } = e.target;
    if (name === 'cancel') {
      setVisible(true);
      setInputMode(false);
      return;
    }

    setVisible(false);
    setInputMode(false);
    setInputData({
      package_id: '',
      os_type: '',
      app_store: '',
      client_version: '',
      client_status: 'test',
      custom_url: '',
      memo: '',
    });
  };

  /// 삭제
  const handleDelete = () => {
    clientDelete({
      package_id: selectData?.package_id,
      client_no: selectData?.client_no,
    });
  };

  const handleSubmit = () => {
    // console.log(inputData);
    inputData?.client_no
      ? clientUpdate({ inputData })
      : clientRegister({ inputData });
  };

  useEffect(() => {
    if (selectData?.app_store === undefined) {
      setInputMode(true);
      setInputData({ ...selectData, ...inputData });
    }
    if (selectData?.app_store) {
      setInputMode(false);
      setInputData(selectData);
    }
    if (inputMode === false || visible === true) {
      setInputData({ ...inputData, ...selectData! });
    }
    if (!visible) {
      setInputData({ ...inputData });
    }
  }, [visible]);

  return (
    // todo: title이 조건별로 들어가야 함. 클라이언트 상세 정보, 클라이언트 정보 수정, {안드로이드 / ios} 클라이언트 등록
    <DefaultModal
      title={t(
        'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.title',
      )}
      visible={visible}
      onCancel={handleModalClose}
      footer={
        <>
          {inputMode ? (
            <DefaultButton onClick={handleSubmit}>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.saveButton',
              )}
            </DefaultButton>
          ) : (
            <>
              <DeletePopConfirm
                title={`${selectData?.client_version} ${t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.deleteConfirm',
                )}`}
                onConfirm={handleDelete}
                notTable
              />
              <DefaultButton onClick={handleUpdateClick}>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.updateButton',
                )}
              </DefaultButton>
            </>
          )}
        </>
      }
    >
      <TwoRowTable thWidth='10rem'>
        <tbody>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.appStore',
              )}
            </th>
            <td>
              {inputMode ? (
                <DefaultSelect
                  name='app_store'
                  value={inputData?.app_store}
                  optionList={storeDropList}
                  onChange={handleSelectChange}
                  bottom
                />
              ) : (
                selectData?.app_store
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.clientVersion',
              )}
            </th>
            <td>
              {inputMode ? (
                <DefaultInput
                  name='client_version'
                  value={inputData?.client_version}
                  onChange={handleInputChange}
                  bottom
                />
              ) : (
                selectData?.client_version
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.clientStatus',
              )}
            </th>
            <td>
              {inputMode ? (
                <DefaultSelect
                  name='client_status'
                  value={inputData?.client_status}
                  optionList={statusDropList}
                  onChange={handleSelectChange}
                  bottom
                />
              ) : (
                <StatusText backColor={inputData?.color}>
                  {selectData?.client_status_KO}
                </StatusText>
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.customURL',
              )}
            </th>
            <td>
              {inputMode ? (
                <DefaultInput
                  name='custom_url'
                  value={inputData?.custom_url}
                  onChange={handleInputChange}
                  bottom
                />
              ) : (
                selectData?.custom_url
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.clientModal.memo',
              )}
            </th>
            <td>
              {inputMode ? (
                <DefaultInput
                  name='memo'
                  value={inputData?.memo}
                  onChange={handleInputChange}
                  bottom
                />
              ) : (
                selectData?.memo
              )}
            </td>
          </tr>
        </tbody>
      </TwoRowTable>
    </DefaultModal>
  );
};

export default ClientDetailModal;
const StatusText = styled.p`
  background-color: ${(props) => `${props.backColor}`};
  color: #fff;
  font-size: 0.8rem;
  padding: 0.08rem 0.3rem;
  border-radius: 0.2rem;
  display: inline-block;
`;
